import { defineStore } from 'pinia';
import { useLocalStorage } from '@src/utils/storage';

export interface MapLayerItem {
    type: string;
    features?: string[];
}

/** 地图展示与底图相关持久化配置（单对象存储，避免多次 useLocalStorage） */
export interface MapSettings {
    /** 腾讯地图底图图层配置序列化（vector、satellite、traffic 等） */
    baseMapLayers: MapLayerItem[];
    /** 矢量底图图层配置 */
    vectorLayer: MapLayerItem | null;
    /** 路况图层配置 */
    trafficLayer: MapLayerItem | null;
    /** 腾讯内置卫星底图图层项 */
    satelliteLayer: MapLayerItem | null;
    /** 底图切换：当前选中的样式或卫星类型 */
    activeBaseMapType: string | null;
}

const createDefaultMapSettings = (): MapSettings => ({
    baseMapLayers: [],
    vectorLayer: null,
    trafficLayer: null,
    satelliteLayer: null,
    activeBaseMapType: null,
});

export const useStoreMapSettings = defineStore('mapSettings', () => {
    const mapSettings = useLocalStorage<MapSettings>('mapSettings', createDefaultMapSettings());

    const patchMapSettings = (patch: Partial<MapSettings>) => {
        mapSettings.value = { ...mapSettings.value, ...patch };
    };

    const resetMapSettings = () => {
        mapSettings.value = createDefaultMapSettings();
    };

    return {
        mapSettings,
        patchMapSettings,
        resetMapSettings,
    };
});
